<template>
	<div class="">
		<header-vue></header-vue>
		<div class="container-l2">
			<el-tabs v-model="activeName" @tab-click="handleClick">
			    <el-tab-pane label="权限管理" name="first">
			    	<rights-manage></rights-manage>
			    </el-tab-pane>
			    <el-tab-pane label="权限分配" name="second">
			    	<rigthsdistribute></rigthsdistribute>
			    </el-tab-pane>
			    <el-tab-pane label="权限明细" name="third">
			    	<rights ref="child1"></rights>
			    </el-tab-pane>
			  </el-tabs>
		</div>
	</div>
	
	
</template>
<script>
//	权限明细组件
	import rights from './rights.vue'
//	权限管理组件
	import rightsManage from './rightsManage.vue'
	//	权限分配
	import rigthsdistribute from './rigthsDistribute.vue'
	export default {
		name: 'rightsHeader',
		components: {
		    rights,
		    rightsManage,
		    rigthsdistribute
		   },
	    data() {
	      return {
	        activeName: 'first'
	      };
	    },
	    methods: {
	      handleClick(tab, event) {
	      	if(this.activeName=="third"){
	      		this.$refs.child1.getRightsList(); 
	      	}
	      }
	    }
	  };
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/device/rightsHeader.vue